// Feature flags. Flip to true when B2C payments (Hotmart checkout) are ready.
// When B2C_ENABLED is false:
//   - Prices and "from $X/month" labels are hidden
//   - Direct Hotmart CTAs are replaced with a lead-capture modal (/api/interest)
//   - Bundle section and Offer section are hidden entirely
//   - Pack nav link is hidden
//   - Pricing-related FAQ entries are filtered out
export const B2C_ENABLED = false;
